import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import History from '../pages/History';
import Customers from '../pages/Customers';
import Coupon from '../pages/Coupon';
import CouponType from '../pages/CouponType';
import Announcements from '../pages/Announcements';
import Users from '../pages/Users';
import PrivateRoute from './PrivateRoute';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute adminOnly>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/customers"
        element={
          <PrivateRoute adminOnly>
            <Customers />
          </PrivateRoute>
        }
      />
      <Route
        path="/coupon-types"
        element={
          <PrivateRoute adminOnly>
            <CouponType />
          </PrivateRoute>
        }
      />
      <Route
        path="/announcements"
        element={
          <PrivateRoute adminOnly>
            <Announcements />
          </PrivateRoute>
        }
      />
      <Route
        path="/users"
        element={
          <PrivateRoute ioyouOnly>
            <Users />
          </PrivateRoute>
        }
      />
      <Route
        path="/history"
        element={
          <PrivateRoute>
            <History />
          </PrivateRoute>
        }
      />
      <Route
        path="/coupons"
        element={
          <PrivateRoute>
            <Coupon />
          </PrivateRoute>
        }
      />
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default AppRoutes;
